/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Erwartungswert } from '../models/Erwartungswert';
import type { ErwartungswertDaten } from '../models/ErwartungswertDaten';
import type { ErwartungswerteListe } from '../models/ErwartungswerteListe';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ErwartungswerteService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Erwartungswerte einer Unteraufgabe suchen
   * Sucht nach Erwartungswerten einer Unteraufgabe
   * @returns ErwartungswerteListe Liste der Erwartungswerte
   * @throws ApiError
   */
  public searchErwartungswerte({
    aufgabeId,
    unteraufgabeId,
  }: {
    /**
     * Eindeutige ID der Aufgabe
     */
    aufgabeId: string,
    /**
     * Eindeutige ID der Unteraufgabe
     */
    unteraufgabeId: string,
  }): CancelablePromise<ErwartungswerteListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/aufgaben/{aufgabeId}/unteraufgaben/{unteraufgabeId}/erwartungswerte',
      path: {
        'aufgabeId': aufgabeId,
        'unteraufgabeId': unteraufgabeId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * Erwartungswert erstellen
   * Erstellt einen Erwartungswert für eine Unteraufgabe
   * @returns Erwartungswert Der erstellte Erwartungswert
   * @throws ApiError
   */
  public createErwartungswert({
    aufgabeId,
    unteraufgabeId,
    requestBody,
  }: {
    /**
     * Eindeutige ID der Aufgabe
     */
    aufgabeId: string,
    /**
     * Eindeutige ID der Unteraufgabe
     */
    unteraufgabeId: string,
    /**
     * Daten für den Erwartungswert
     */
    requestBody: ErwartungswertDaten,
  }): CancelablePromise<Erwartungswert> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/aufgaben/{aufgabeId}/unteraufgaben/{unteraufgabeId}/erwartungswerte',
      path: {
        'aufgabeId': aufgabeId,
        'unteraufgabeId': unteraufgabeId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * Erwartungswert abrufen
   * Holt einen Erwartungswert
   * @returns Erwartungswert Der Erwartungswert
   * @throws ApiError
   */
  public getErwartungswert({
    aufgabeId,
    unteraufgabeId,
    erwartungswertId,
  }: {
    /**
     * Eindeutige ID der Aufgabe
     */
    aufgabeId: string,
    /**
     * Eindeutige ID der Unteraufgabe
     */
    unteraufgabeId: string,
    /**
     * Eindeutige ID des Erwartungswerts
     */
    erwartungswertId: string,
  }): CancelablePromise<Erwartungswert> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/aufgaben/{aufgabeId}/unteraufgaben/{unteraufgabeId}/erwartungswerte/{erwartungswertId}',
      path: {
        'aufgabeId': aufgabeId,
        'unteraufgabeId': unteraufgabeId,
        'erwartungswertId': erwartungswertId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Erwartungswert aktualisieren
   * Aktualisiert einen Erwartungswert
   * @returns Erwartungswert Der aktualisierte Erwartungswert
   * @throws ApiError
   */
  public updateErwartungswert({
    aufgabeId,
    unteraufgabeId,
    erwartungswertId,
    requestBody,
  }: {
    /**
     * Eindeutige ID der Aufgabe
     */
    aufgabeId: string,
    /**
     * Eindeutige ID der Unteraufgabe
     */
    unteraufgabeId: string,
    /**
     * Eindeutige ID des Erwartungswerts
     */
    erwartungswertId: string,
    /**
     * Daten für den Erwartungswert
     */
    requestBody: ErwartungswertDaten,
  }): CancelablePromise<Erwartungswert> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/v1/aufgaben/{aufgabeId}/unteraufgaben/{unteraufgabeId}/erwartungswerte/{erwartungswertId}',
      path: {
        'aufgabeId': aufgabeId,
        'unteraufgabeId': unteraufgabeId,
        'erwartungswertId': erwartungswertId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Erwartungswert löschen
   * Löscht einen Erwartungswert
   * @returns Erwartungswert Der gelöschte Erwartungswert
   * @throws ApiError
   */
  public deleteErwartungswert({
    aufgabeId,
    unteraufgabeId,
    erwartungswertId,
  }: {
    /**
     * Eindeutige ID der Aufgabe
     */
    aufgabeId: string,
    /**
     * Eindeutige ID der Unteraufgabe
     */
    unteraufgabeId: string,
    /**
     * Eindeutige ID des Erwartungswerts
     */
    erwartungswertId: string,
  }): CancelablePromise<Erwartungswert> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/aufgaben/{aufgabeId}/unteraufgaben/{unteraufgabeId}/erwartungswerte/{erwartungswertId}',
      path: {
        'aufgabeId': aufgabeId,
        'unteraufgabeId': unteraufgabeId,
        'erwartungswertId': erwartungswertId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

}
